export type TextSpanInfo = {
  text: string;
  href?: string;
};

// Conservative URL matcher: requires explicit http/https protocol.
// The legacy parser also detects bare-domain URLs via a TLD allow-list
// — that's a follow-up; matching with the explicit protocol covers
// what users typically paste into chat without the false-positive
// risk of catching e.g. file names or version strings.
const urlRegex = /\bhttps?:\/\/[^\s<>]+[^\s<>.,;:!?)]/gi;

/**
 * Split a chat message body into alternating plain-text and URL spans.
 * Returns at least one span (the entire input as plain text when no
 * URL is found).
 */
export function parseTextToSpans(text: string): TextSpanInfo[] {
  const spans: TextSpanInfo[] = [];
  let lastIndex = 0;

  for (const match of text.matchAll(urlRegex)) {
    const start = match.index ?? 0;
    if (start > lastIndex) {
      const before = text.slice(lastIndex, start);
      if (before) spans.push({ text: before });
    }
    spans.push({ text: match[0], href: match[0] });
    lastIndex = start + match[0].length;
  }

  if (lastIndex < text.length) {
    const tail = text.slice(lastIndex);
    if (tail) spans.push({ text: tail });
  }

  if (spans.length === 0) {
    spans.push({ text });
  }

  return spans;
}
